// add_to_cart_script.js
document.addEventListener('DOMContentLoaded', function() {
    console.log("testing plugin");
    var addToCartButton = document.querySelector('.AddtoCart.js-ajax-submit'); // Adjust this selector according to your theme
    if (addToCartButton) {
        addToCartButton.addEventListener('click', function() {
            // Your custom logic here
            alert('Item added to cart!');
        });
    }
});
